// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-input {
  border-color: #d2d6de;
  margin-top: 0;
  margin-right: 0;
}

.form-input[type="checkbox"] {
  margin-top: 12px;
}

.form-input:focus {
  border-color: #3c8dbc;
}

.form-input--error, .form-input--error:focus {
  border-color: var(--danger);
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/FormInput/FormInput.css","webpack://./services/frontend/app/components/FormInput/FormInput.css"],"names":[],"mappings":"AADA;ECEE,qBAAqB;EACrB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".form-input {\n  border-color: #d2d6de;\n  margin-right: 0;\n  margin-top: 0;\n}\n\n  .form-input[type='checkbox'] {\n    margin-top: 12px;\n  }\n\n  .form-input:focus {\n    border-color: #3c8dbc;\n  }\n\n.form-input--error {\n  border-color: var(--danger);\n}\n\n.form-input--error:focus {\n    border-color: var(--danger);\n  }\n",".form-input {\n  border-color: #d2d6de;\n  margin-top: 0;\n  margin-right: 0;\n}\n\n.form-input[type=\"checkbox\"] {\n  margin-top: 12px;\n}\n\n.form-input:focus {\n  border-color: #3c8dbc;\n}\n\n.form-input--error, .form-input--error:focus {\n  border-color: var(--danger);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
